import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import LoginResponse from './views/LoginResponse.vue'
import CookieManager from './helpers/cookiemanager'
import Config from './config'
import { AppState } from './state'
import { ActiveUser } from '@/models/user'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'Dashboard' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Login', userNotRequire: true }
    },
    {
      path: '/login-response',
      name: 'loginResponse',
      component: LoginResponse,
      meta: { title: 'Login Validation', userNotRequire: true }
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: () => import('./views/Accounts.vue'),
      meta: { title: 'Accounts' }
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import('./views/Categories.vue'),
      meta: { title: 'Transaction Categories' }
    },
    {
      path: '/tags',
      name: 'tags',
      component: () => import('./views/Tags.vue'),
      meta: { title: 'Tags' }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: () => import('./views/Transactions.vue'),
      meta: { title: 'Transactions' }
    },
    {
      path: '/transactions/create',
      name: 'transactions-create',
      component: () => import('./views/CreateTransactions.vue'),
      meta: { title: 'Create Transactions' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  AppState.resetBreadcrumb()

  let docTitle = Config.title

  // Ref: https://alligator.io/vuejs/vue-router-modify-head/
  const docTitleFound = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const pageTitleFound = to.matched.slice().reverse().find(r => r.meta && r.meta.pageTitle)

  if (docTitleFound) {
    docTitle = docTitleFound.meta.title
  }

  let pageTitle = docTitle
  if (pageTitleFound) {
    /* eslint-disable prefer-destructuring */
    pageTitle = pageTitleFound.meta.pageTitle
  }

  AppState.updateTitles(docTitle, pageTitle)
  AppState.updateActivePage(to.name)

  if (to.matched.some(record => record.meta.userNotRequire)) {
    next()
  } else {
    const token = CookieManager.getItem('rzAccessToken')
    const forAppkey = CookieManager.getItem('rzForAppkey')
    if (token === undefined || token === null || token === '') {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else if (!ActiveUser.user.key) {
      AppState.updateUserLoggedIn(true)
      ActiveUser.user.updateFromServer(ActiveUser.state).then(() => {
        console.log('Fetching User Profile')
        AppState.prepareInitData(next)
      })
    } else {
      console.log('Skipping', to.fullPath)
      AppState.prepareInitData(next)
    }
  }
})

export default router
